module.exports = __webpack_public_path__ + "img/snb_gsnd.8012144c.svg";